// extracted by mini-css-extract-plugin
export default {"container":"register-loading_container__X3Vqj","icon":"register-loading_icon__o1HhB","message":"register-loading_message__4wrHp","shimmer":"register-loading_shimmer__z6aPr"};